import React from 'react';
import moment from 'moment';
import MilestoneLines from './milestones/milestone_lines';

/**
 * @typedef TicksProps
 * @prop {*=} scale
 * @prop {*=} width
 * @prop {*=} milestones
 * @prop {*=} topOffset
 * @prop {*=} showMilestoneBars
 */
/**
 * @type {React.FC<TicksProps>}
 */
function Ticks({ scale, width, milestones, topOffset, showMilestoneBars }) {
  let weekends;

  if (scale.hideWeekends || scale.majorInterval === 'year') {
    weekends = null;
  } else {
    weekends = scale.weekends().map((date, index) => (
      <div
        key={`${index}-${date.unix()}`}
        className='weekend'
        style={{
          left: scale.dateToOffset(date),
          width: scale.pixelsPerDay * 2,
        }}
      />
    ));
  }
  const ticks = scale
    .majorIntervals()
    .map((date, index) => (
      <div
        key={`${index}-${date.unix()}`}
        className='tick'
        style={{ left: scale.dateToOffset(date) }}
      />
    ));

  const today = (
    <div
      className='roadmap-today-line'
      style={{ left: scale.dateToRawOffset(moment.utc()) }}
    />
  );

  return (
    <div
      key='TickContainer'
      className='tick-container'
      style={{ width: width - 1, marginTop: topOffset }}
    >
      {weekends}
      {ticks}
      {today}
      <MilestoneLines
        scale={scale}
        milestones={milestones}
        showMilestoneBars={showMilestoneBars}
      />
    </div>
  );
}

export default React.memo(Ticks);
